<template>
  <v-app
    id="inspire"
    class="blue lighten-5"
  >
    <v-main :style="{backgroundImage: this.pageBackgroundImage , backgroundSize: 'cover'}">
      <MinimizedSession v-if="session_info != null" />
      <router-view />
    </v-main>
    <v-card>
    <v-footer padless class="rounded-t-lg mx-auto" fixed :max-width="maxWidth">
      <v-tabs
        background-color="white"
        icons-and-text
        class="rounded-t-lg"
        :show-arrows="true"
        centered
        :mobile-breakpoint="maxWidth"
      >
        <div class="d-flex align-center justify-start">
          <v-card class="pa-2" to="/" max-width="150" flat>
            <v-img src="/img/footer_logo.png"></v-img>
          </v-card>
        </div>
        <v-tab :to="(menu.route) ? menu.route : ''" :href="(menu.href) ? menu.href : ''" :target="menu.target" v-for="menu in menus" :key="menu.title" @click="showPopup(menu.is_popup)" :class="menu.class" style="font-size:0.75rem">
          {{menu.title}}
          <v-avatar size="35" tile>
            <v-img :src="menu.icon"></v-img>
          </v-avatar>
        </v-tab>
        <div class="d-flex align-center">
          <v-carousel
            v-model="selected_slide"
            hide-delimiters
            :show-arrows="false"
            style="width: 120px"
            height="60"
            :vertical="true"
            interval="5000"
            cycle
          >
            <v-carousel-item v-for="item in object_list" :key="item.position_id" :src="item.upload_url" :href="item.link" target="_blank"></v-carousel-item>
          </v-carousel>
        </div>
        <!-- <div class="d-flex align-center pl-2" v-if="object_list.length>=1">
          <v-btn-toggle class="d-flex flex-column" background-color="grey lighten-2">
            <v-icon @click="selected_slide--" class="my-1">mdi-chevron-up</v-icon>
            <v-icon @click="selected_slide++" class="my-1">mdi-chevron-down</v-icon>
          </v-btn-toggle>
        </div> -->
      </v-tabs>
    </v-footer>
  </v-card>
    <Alert />
    <Notifications />
    <AttendeePopup/>
    <TotebagPopup/>
    <AgendaPopup/>
  </v-app>
</template>
<script>
import axios from "@/helper/axios";
import Alert from "@/components/Alert.vue";
import MinimizedSession from '../session/Minimized'
import Notifications from '../afterAuth/Notifications'
import AttendeePopup from "@/components/Attendee.vue";
import TotebagPopup from "@/components/Totebag.vue";
import AgendaPopup from "@/components/Agenda.vue";
import WsSubscriptions from '../../helper/websocket'
import {mapState,mapActions,mapMutations,mapGetters} from 'vuex';
export default {
  props: {
    source: String,
  },
  components: {
    Alert,
    MinimizedSession,
    Notifications,
    AttendeePopup,
    TotebagPopup,
    AgendaPopup,
  },
  data() {
    return {
      selected_slide: 0,
      attendee_list:[],
      menus : [
        { 
          title : 'Main Lobby',
          route : '/',
          icon : '../img/main_lobby.svg',
          class : 'v-step-1',
          is_popup : false
        },
        { title : 'Auditorium',
         route : '/session',
         icon : '../img/auditorium.svg',
         class : 'v-step-2',
         is_popup : false
        },
        { 
          title : 'Vendor Hall', 
          route : '/vendor-hall', 
          icon : '../img/vendor_hall.svg',
          class : 'v-step-3',
          is_popup : false
        },
        { 
          title : 'Networking Room', 
          route : '/networking-room', 
          icon : '../img/networking_room.svg',
          class : 'v-step-4',
          is_popup : false
        },
        { 
          title : 'Info desk', 
          route : '/info-desk', 
          icon : '../img/info_desk.svg',
          class : 'v-step-5',
          is_popup : false
        },
        // { 
        //   title : 'Attendee', 
        //   route : '', 
        //   icon : '../img/attendee.svg',
        //   class : 'v-step-6',
        //   is_popup : 'attendee'
        // },
        { 
          title : 'Agenda', 
          route: '',  
          icon : '../img/agenda.svg',
          class : 'v-step-6',
          is_popup : 'agenda'
        },
        { 
          title : 'Tote Bag',
          route : '', 
          icon : '../img/tote_bag.svg',
          class : 'v-step-7',
          is_popup : 'totebag'
        },
        {
          title: "Profile",
          route: "/profile",
          icon: "img/user.svg",
          is_popup: false,
          class: "v-step-8",
        },
      ],
      object_list : [],
    };
  },
  computed: {
    ...mapState('active_session',['session_info']),
    ...mapGetters('notifications',["existingPrivateMembers"]),
    ...mapState('notifications',["is_msg_expand","incoming_rintone"]),
    ...mapState('utils',['maxWidth','pageBackgroundImage']),
    pageTitle() {
      return this.$route.meta.title;
    },
    myself() {
      return JSON.parse(localStorage.getItem("flaacos_user"));
    },
  },
  methods: {
    ...mapActions('notifications',["getInfoDeskMessage","getPrivateMessages"]),
    ...mapMutations("attendees", ["setData"]),
    ...mapMutations("totebag", ["setTotebagData"]),
    ...mapMutations("agenda", ["setAgendaData"]),
    ...mapMutations("notifications", ["addNotification","updateUnreadCounter"]),
    logout() {
      localStorage.removeItem("flaacos_user");
      this.$router.push("/login");
    },
    showPopup(title){
      if(title=='attendee'){
        this.setData({
          key : 'show_modal',
          data : true
        })
      }
      if(title=='totebag'){
        this.setTotebagData({
          key : 'show_totebag_modal',
          data : true
        })
      }
      if(title=='agenda'){
        this.setAgendaData({
          key : 'show_agenda_modal',
          data : true
        })
      }
    },
    setBoothNotification(data){
      data.type = 'booth_visit'
      this.addNotification({
        data : data,    
        color : 'purple',
        position : ''
      })
      this.incoming_rintone.play()
    },
    setNotification(data) {
      if(data.type == "infodesk"){
        this.getInfoDeskMessage()
         if(this.is_msg_expand != 0){
           data.no_timeout = true
           this.addNotification({
              data : data,
              color : 'green darken-3',
              max_width : '500'
            })
         }
      }
      if(data.type == "private_message"){
        if(data.send_by != this.myself.attendee_id){
          let existingMember = this.existingPrivateMembers.filter((eAttendee) => {
            return eAttendee.attendee_id == data.send_by
          }).length
          if(existingMember == 0) {
            this.getPrivateMessages()
          }
          //show popup if chatbox not expanded
          if(this.is_msg_expand != 0){
            if(existingMember != 0){
              this.updateUnreadCounter(data)
            }
            this.addNotification({
              data : data,
              color : 'blue'
            })
          }
          if(this.is_msg_expand == 0 && existingMember != 0){
            this.updateUnreadCounter(data)
          }
        }
      }
    },
    setGeneralNotification(data){
      data.no_timeout = true
      this.addNotification({
        data : data,
        color : 'green darken-3',
        max_width : '500',
        position : 'top-right'
      })
    },
    getObjects() {
      let _self = this;
      axios
        .get("object/get?page_name=HEADER_MENU")
        .then(function (response) {
          if(response.data.status){
            _self.object_list = response.data.data;
          }
        })
        .catch(function (e) {
          console.log(e);
        });
      _self.loading = false;
    },
    addSiteView() {
      axios.post("/add_site_view")
      .then(function () { })
      .catch(function (e) {
        console.log(e);
      });
    }
  },
  async created() {
    this.getObjects()
    let user = JSON.parse(localStorage.getItem('flaacos_user'))
    await WsSubscriptions(user.attendee_token)
    this.addSiteView()
    let subscription = this.$ws.socket.getSubscription(`user:${this.myself.attendee_id}`);
    if (!subscription) {
      this.$ws.subscribe(`user:${this.myself.attendee_id}`)
      this.$ws.$on(`user:${this.myself.attendee_id}|general_notification`, this.setGeneralNotification)
      this.$ws.$on(`user:${this.myself.attendee_id}|notification`, this.setNotification)
      this.$ws.$on(`user:${this.myself.attendee_id}|booth_visit`, this.setBoothNotification)
      this.$ws.$on(`user:${this.myself.attendee_id}|new_message`, this.setNotification)
    } else {
      this.$ws.$on(`user:${this.myself.attendee_id}|general_notification`, this.setGeneralNotification)
      this.$ws.$on(`user:${this.myself.attendee_id}|notification`, this.setNotification)
      this.$ws.$on(`user:${this.myself.attendee_id}|booth_visit`, this.setBoothNotification)
      this.$ws.$on(`user:${this.myself.attendee_id}|new_message`, this.setNotification)
    }
  },
  beforeDestroy(){
    let subscription = this.$ws.socket.getSubscription(
        `user:${this.myself.attendee_id}`
      );
    if(subscription){
      subscription.close()
      this.$ws.socket.removeSubscription(`user:${this.myself.attendee_id}`)
    }
  }
};
</script>
<style>
.draggable{
  position: absolute;
  z-index: 1 !important;
}
.cursor_pointer{
  cursor: pointer;
}
</style>
